import Vue from 'vue'
import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

const validateInterests = interests => {
  if (!interests) return false

  if (Array.isArray(interests.id)) {
    return !!interests.id.length
  }

  return false
}

export default {
  state: () => createPlatformState(),
  actions: {
    async fetchProfile ({ commit }) {
      const profile = await platformAction({
        client: this.$api.profiles,
        method: 'get',
        commit,
        logError: this.$logError,
        commitData: false,
        include: []
      })

      commit('saveProfile', profile)
    },

    async updateProfile ({ commit }, params) {
      const profile = await platformAction({
        client: this.$api.profiles,
        method: 'update',
        commit,
        params,
        logError: this.$logError,
        commitData: false
      })

      if (profile) {
        commit('saveProfile', profile)
      }
    }
  },
  getters: {
    ...platformGetters,
    profile: s => s.data,
    profileComplete: s => {
      const fieldKeys = ['occupation', 'natureOfBusiness', 'city', 'bio', 'askMeAbout', 'instagramHandle', 'twitterHandle', 'linkedinUrl', 'spotifyUrl', 'youtubeUrl', 'website']
      const validatedKeys = fieldKeys.some(key => {
        const value = s.data[key]

        if (Array.isArray(value)) {
          return !!value.length
        }

        return !!value
      })

      const hasInterests = s.data.relationships
        ? validateInterests(s.data.relationships.interests)
        : false

      return validatedKeys || hasInterests
    },
    profileFetching: s => s.meta.fetching,
    profileUpdateFailed: s => s.meta.failed,
    profileObsceneError: s => {
      if (s.meta.errorMessages.length) {
        const { code } = s.meta.errorMessages[0]

        if (code.match(/OBSCENE/)) {
          const [, ...id] = code.split('_')
          return id.join('_').toLowerCase()
        }
      }

      return false
    }
  },
  mutations: {
    ...platformMutations,
    saveProfile (s, profile) {
      Vue.set(s, 'data', profile)
    }
  }
}
